/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"
import { PaymentInvoiceBySO } from "../../types"

type UsePaymentInvoiceListBySoProps = {
  params: {
    sales_order_id?: number
  }
}

type Response = {
  payload: PaymentInvoiceBySO[]
}

export function usePaymentInvoiceListBySo({
  params
}: UsePaymentInvoiceListBySoProps) {
  const api = useApi()
  const [data, setData] = useState<Response["payload"]>([])
  const [isLoading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)

    api
      .get("paymentinvoice/payment_invoice_by_so", { params })
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? []
        setData(data)
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    if (params.sales_order_id) {
      fetchData()
    }

    return () => {
      setData([])
      setLoading(false)
    }
  }, [params.sales_order_id])

  return {
    data,
    isLoading,
    refetch,
    dropdown: data.map((item) => ({ value: item, label: item }))
  }
}
